import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { ArticleV1, ArticleContentMetaV2 } from '@ilteducation/content-registry-types';
import { generateExercise } from '@/data-provider/aiService';
import eventBus from '@/foundations/services/eventBus';

type Props = {
  item: ArticleV1;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ArticleQuestionForm',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: ArticleV1;
}



const questionTypes = ['short_answer', 'discussion'];

const isArticleContentMetaV2 = (val: any): val is ArticleContentMetaV2 => val !== undefined && val.path !== undefined;

const createExercise = async (
  articleId: string,
  questionType: 'short_answer' | 'discussion',
  realm: string | undefined,
  language: string | undefined,
  path: string | undefined,
) => {
  await generateExercise(articleId, questionType, realm, language, path);
  eventBus.$emit('snackbar.open', `Generation of AI questions started for article ${articleId} `);
};

const selectedType = ref();

const exerciseField = ref([
  { source: 'id', link: 'edit', sortable: false },
  {
    source: 'title',
    sortable: true,
  },
]);

const listInclude = ref([
  {
    contentType: 'Exercise',
  },
]);

const language = props.item.publisher?.includes('BBC') ? 'en' : 'swe';

return { __sfc: true,props, questionTypes, isArticleContentMetaV2, createExercise, selectedType, exerciseField, listInclude, language }
}

})